import { getEnvConfig } from '@hbs-us/contracts';

import { getAppEnv } from '../../lib/env.js';

/**
 * Credentialed download URL for a change order document.
 *
 * The api host comes from `@hbs-us/contracts`, never a hardcoded string (T-21-07) — the same rule
 * the estimate and invoice export links follow, and the reason those survived the rebrand.
 */
function apiBaseUrl(): string {
  // `domains.api` is a BARE HOST (`api.dev.qelm.app`), so the scheme has to be added here — the
  // same as the estimate link does. Without it the URL is neither absolute nor relative:
  // `downloadCredentialed` fails to parse it, falls through to its "already relative" branch, and
  // apiFetch concatenates it onto the api base to produce `https://api.dev.qelm.appapi.dev...`,
  // which fails DNS. The rejection is swallowed by the caller's catch, so the button does nothing
  // at all and reports nothing.
  return `https://${getEnvConfig(getAppEnv()).domains.api}`;
}

export function changeOrderPdfUrl(id: number): string {
  return `${apiBaseUrl()}/api/v1/change-orders/${id}/pdf`;
}
